export interface InvestmentExperience {
  bonds: Experience;
}

export interface Experience {
  tradesPerYear: number;
  yearsTrading: number;
  knowledgeLevel: KnowledgeLevel;
}

export const knowledgeLevels = ["None", "Limited", "Good", "Extensive"] as const;
export type KnowledgeLevel = typeof knowledgeLevels[number];
